const parseValue = raw => {
  if (raw == null) return null;
  if (typeof raw === 'object') return raw;
  try {
    return typeof raw === 'string' ? JSON.parse(raw) : raw;
  } catch {
    return null;
  }
};

const normalizeItem = item => {
  if (!item) return item;
  return {
    ...item,
    value: parseValue(item.value),
  };
};

/**
 * Prioridade: placeId > condominiumPersonContextId > partnerPersonContextId.
 * Envia apenas um dos três no body.
 */
const buildContextIds = ({
  placeId,
  condominiumPersonContextId,
  partnerPersonContextId,
}) => {
  if (placeId != null) {
    return {
      placeId,
      condominiumPersonContextId: null,
      partnerPersonContextId: null,
    };
  }
  if (condominiumPersonContextId != null) {
    return {
      placeId: null,
      condominiumPersonContextId,
      partnerPersonContextId: null,
    };
  }
  if (partnerPersonContextId != null) {
    return {
      placeId: null,
      condominiumPersonContextId: null,
      partnerPersonContextId,
    };
  }
  return {
    placeId: null,
    condominiumPersonContextId: null,
    partnerPersonContextId: null,
  };
};

export const getList = async ({ $httpMonitoring, filters = {} }) => {
  const params = {
    ...(filters.partnerPersonContextId != null && {
      partnerPersonContextId: filters.partnerPersonContextId,
    }),
    ...(filters.condominiumPersonContextId != null && {
      condominiumPersonContextId: filters.condominiumPersonContextId,
    }),
    ...(filters.placeId != null && { placeId: filters.placeId }),
    ...(filters.names && filters.names.length ? { names: filters.names } : {}),
    ...(filters.eventTypes && filters.eventTypes.length
      ? { eventTypes: filters.eventTypes }
      : {}),
  };

  const res = await $httpMonitoring.get('/eventTriggerSetting', { params });

  if (res.status === 204 || !res.data || !res.data.eventTriggerSettings) {
    return [];
  }

  return (res.data.eventTriggerSettings || []).map(normalizeItem);
};

export const get = async ({ id, $httpMonitoring }) => {
  const res = await $httpMonitoring.get(`/eventTriggerSetting/${id}`);

  if (res.status === 204 || !res.data || !res.data.eventTriggerSetting) {
    return null;
  }

  return normalizeItem(res.data.eventTriggerSetting);
};

export const create = async ({ input, $httpMonitoring }) => {
  const contextIds = buildContextIds({
    placeId: input.placeId,
    condominiumPersonContextId: input.condominiumPersonContextId,
    partnerPersonContextId: input.partnerPersonContextId,
  });

  const body = {
    eventType: input.eventType,
    name: input.name,
    value: input.value,
    ...contextIds,
  };

  const res = await $httpMonitoring.post('/eventTriggerSetting', body);

  if (res.status === 204 || !res.data || !res.data.eventTriggerSetting) {
    return null;
  }

  return normalizeItem(res.data.eventTriggerSetting);
};

export const update = async ({ id, input, $httpMonitoring }) => {
  const contextIds = buildContextIds({
    placeId: input.placeId,
    condominiumPersonContextId: input.condominiumPersonContextId,
    partnerPersonContextId: input.partnerPersonContextId,
  });

  const body = {
    eventType: input.eventType,
    name: input.name,
    value: input.value,
    ...contextIds,
  };

  const res = await $httpMonitoring.put(`/eventTriggerSetting/${id}`, body);

  if (res.status === 204 || !res.data || !res.data.eventTriggerSetting) {
    return null;
  }

  return normalizeItem(res.data.eventTriggerSetting);
};

export const remove = async ({ id, $httpMonitoring }) => {
  const res = await $httpMonitoring.delete(`/eventTriggerSetting/${id}`);
  return res.status === 200;
};
